import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { ArtikelbezeichnungsgeneratorBausteinDto } from '../entities/articles/artikelbezeichnungsgeneratorbausteindto.entity';
//#endregion

@Injectable()
export class ArtikelbezeichnungsgeneratorBausteineService extends ODataEntityService<ArtikelbezeichnungsgeneratorBausteinDto> {
  constructor(protected client: ODataClient) {
    super(client, 'ArtikelbezeichnungsgeneratorBausteine', 'entities.articles.ArtikelbezeichnungsgeneratorBausteinDto');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
